import { useState, useEffect } from "react";
import { apiGET, apiIsCancelled } from "./APIHook";
import { API_ENDPOINTS } from "../config";

export const useAuth = () => {
  const [data, setData] = useState({ status: "pending" });

  const loadAuthInfo = (signal) => {
    const url = API_ENDPOINTS.userInfo;
    setData({ status: "pending" });

    apiGET(url, {
      signal,
    })
      .then((result) => {
        setData({
          status: "ok",
          ...result.data,
        });
      })
      .catch((err) => {
        if (apiIsCancelled(err)) {
          console.log("request aborted!");
          return;
        }
        setData({
          status: "error",
          error: err,
        });
      });
  };

  useEffect(() => {
    const controller = new AbortController();
    loadAuthInfo(controller.signal);
    return () => {
      controller.abort();
    };
  }, []);

  return { auth: data, refresh: loadAuthInfo };
};
